import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../shared/services/auth.service';
import { CustomDateParserFormatter } from '../../../shared/services/datepicker-adapter';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'mtm-summary-block',
  templateUrl: './summary-block.component.html',
  styleUrl: './summary-block.component.scss',
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
  standalone: false,
})
export class SummaryBlockComponent implements OnInit, OnDestroy {
  @Input() timelineData: any;
  @Input() isDownloadComponentActive: boolean = false;
  @Input() workspaceName: string;
  summaryDetail: any;
  priority: string = '';
  colors = {
    CAMPAIGN: '#000000',
    PRODUCT: '#1E43A1',
    MAGELLAN: '#1E43A1',
    'COLLECTOR / PRODUCT': '#086289',
    GIFT: '#923065',
    SET: '#502B9D',
  };
  companyUsers: any[] = [];
  companyId: any;

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    const { companyId } = this.authService.getAuthUser();
    this.companyId = companyId;
    try {
      if (this.timelineData) {
        this.priority = this.timelineData.priority;
        if (typeof this.timelineData.timelineCriteria == 'string') {
          const criteria = JSON.parse(this.timelineData.timelineCriteria);
          this.summaryDetail = criteria;
        } else {
          const criteria = this.timelineData.timelineCriteria;
          this.summaryDetail = criteria;
        }
      }
    } catch (error) {
      console.error('Error in ngOnInit:', error);
      // Handle the error as needed
    }
    this.getCompanyusers();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getFormatedDate(timestamp: number): { year: number; month: number; day: number } {
    const date = new Date(timestamp);
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
    };
  }

  getCompanyusers() {
    this.userService
      .getUsersByCompanyId(this.companyId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.companyUsers = data;
      });
  }

  getUserInfo(email: string): string {
    const user = this.companyUsers?.find((user) => user.username === email);
    return user ? user.fullName : email;
  }
}
